class SandlotCollection extends HTMLElement {
  connectedCallback() {
    this.controller = new AbortController();
    const options = { signal: this.controller.signal };
    this.dialog = this.querySelector('.sg-filter-dialog');
    this.opener = this.querySelector('[data-sg-filter-open]');
    this.sort = this.querySelector('.sg-sort');
    this.addEventListener('click', event => {
      if (event.target.closest('[data-sg-filter-open]')) {
        this.sort.open = false;
        this.dialog.showModal();
        this.opener.setAttribute('aria-expanded', 'true');
        document.body.setAttribute('data-sg-filter-open', '');
      }
      if (event.target.closest('[data-sg-filter-close]')) this.dialog.close();
    }, options);
    this.dialog.addEventListener('click', event => {
      if (event.target === this.dialog) {
        const rect = this.dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
      }
    }, options);
    this.dialog.addEventListener('close', () => {
      this.opener.setAttribute('aria-expanded', 'false');
      document.body.removeAttribute('data-sg-filter-open');
      this.opener.focus();
    }, options);
    this.querySelectorAll('form').forEach(form => form.addEventListener('formdata', event => {
      form.querySelectorAll('input[type="number"]').forEach(input => { if (!input.value) event.formData.delete(input.name); });
    }, options));
    document.addEventListener('click', event => { if (!this.sort.contains(event.target)) this.sort.open = false; }, options);
    this.addEventListener('keydown', event => {
      if (event.key === 'Escape' && this.sort.open) {
        this.sort.open = false;
        this.sort.querySelector('summary').focus();
      }
    }, options);
  }
  disconnectedCallback() {
    this.controller?.abort();
    if (this.dialog?.open) this.dialog.close();
    document.body.removeAttribute('data-sg-filter-open');
  }
}
class SandlotProductTile extends HTMLElement {
  connectedCallback() {
    this.controller = new AbortController();
    this.addEventListener('click', event => {
      const swatch = event.target.closest('[data-sg-swatch]');
      if (!swatch || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      if (!swatch.dataset.price) return;
      event.preventDefault();
      this.querySelectorAll('[data-sg-swatch]').forEach(other => other.removeAttribute('aria-current'));
      swatch.setAttribute('aria-current', 'true');
      this.querySelectorAll('[data-sg-product-link]').forEach(link => link.href = swatch.href);
      const image = this.querySelector('.sg-grid-card__image img');
      if (image && swatch.dataset.image) {
        image.removeAttribute('srcset');
        image.src = swatch.dataset.image;
        image.alt = swatch.dataset.imageAlt || '';
      }
      const price = this.querySelector('[data-sg-price]');
      price.replaceChildren();
      const amount = document.createElement('span');
      amount.className = 'sg-grid-card__amount';
      amount.textContent = swatch.dataset.price;
      price.append(amount);
      if (swatch.dataset.compare) {
        const compare = document.createElement('s');
        compare.textContent = swatch.dataset.compare;
        price.append(' ', compare);
      }
      this.querySelector('[data-sg-color]').textContent = swatch.dataset.color;
      this.dataset.onSale = swatch.dataset.compare ? 'true' : 'false';
      this.querySelector('[data-sg-sold-out-badge]').hidden = swatch.dataset.available !== 'false';
      this.querySelector('[data-sg-sale-badge]').hidden = !swatch.dataset.compare || swatch.dataset.available === 'false';
    }, { signal: this.controller.signal });
  }
  disconnectedCallback() { this.controller?.abort(); }
}
if (!customElements.get('sandlot-collection')) customElements.define('sandlot-collection', SandlotCollection);
if (!customElements.get('sandlot-product-tile')) customElements.define('sandlot-product-tile', SandlotProductTile);
